import { render } from "./DialogMacchina.vue?vue&type=template&id=965afc72"
import script from "./DialogMacchina.vue?vue&type=script&lang=js"
export * from "./DialogMacchina.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__